import React from 'react';

const Introduction: React.FC = () => {
  return (
    <div className="space-y-4">
      <p>Welcome to FeelHeard.me. We've written these terms to help you understand what you can expect from us, and what we expect from you. While this is a legal document, we've done our best to make it clear and accessible.</p>
      
      <div className="bg-[#B3D9E6]/10 p-4 rounded-lg">
        <p className="text-sm">Last Updated: March 15, 2025</p>
        <p className="text-sm">Version: 2.1</p>
      </div>

      <p>By using FeelHeard.me, you agree to these terms. Please read them carefully. If you don't agree with them, you should not use our service.</p>
    </div>
  );
};

export default Introduction;